import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Light as SyntaxHighlighter } from 'react-syntax-highlighter';
import js from 'react-syntax-highlighter/dist/cjs/languages/hljs/javascript';
import shell from 'react-syntax-highlighter/dist/cjs/languages/hljs/powershell';
import json from 'react-syntax-highlighter/dist/cjs/languages/hljs/json';
import github from 'react-syntax-highlighter/dist/cjs/styles/hljs/github';

SyntaxHighlighter.registerLanguage('javascript', js);
SyntaxHighlighter.registerLanguage('bash', shell);
SyntaxHighlighter.registerLanguage('json', json);

export default class CodeSnippet extends Component {
    constructor(props) {
        super(props);
        this.codeRef = React.createRef();
    }

    render() {
        const { codeString, language, className } = this.props;
        return (
            <SyntaxHighlighter className={className} language={language} style={github}>
                {codeString}
            </SyntaxHighlighter>
        );
    }
}

CodeSnippet.defaultProps = {
    codeString: '',
    className: '',
};
CodeSnippet.propTypes = {
    codeString: PropTypes.string,
    className: PropTypes.string,
    language: PropTypes.string.isRequired,
};
